export const findIndices = (regexp: RegExp, str: string) => {
  return Array.from(str.matchAll(regexp)).map((r) => r.index!);
};
